import { Box, Button } from '@mui/material';
import type { FC } from 'react';
import { useDispatch } from 'react-redux';

import { gotoClientPortal } from '../../../../store/actions/route';

type Props = {
  embeddedSessionToken: string;
};

const AlreadyHaveAnAccountButton: FC<Props> = ({ embeddedSessionToken }) => {
  const dispatch = useDispatch();

  return (
    <Box mt={3}>
      <Button
        variant="text"
        fullWidth
        size="large"
        onClick={() => dispatch(gotoClientPortal({ embeddedSessionToken }))}
      >
        Already have a Coast account? Click here to log in.
      </Button>
    </Box>
  );
};

export { AlreadyHaveAnAccountButton };
